import { motion } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { WA_LINKS } from "../lib/utils";

const CITIES = [
{ name: "New Delhi NCR", note: "Capital region coverage", hot: true },
{ name: "Mumbai", note: "Premium coastal properties" },
{ name: "Bengaluru", note: "Tech hub apartments ,villas\xA0& commercial properties", hot: true },
{ name: "Kolkata", note: "Heritage & modern assets" },
{ name: "Hyderabad", note: "Commercial & residential" },
{ name: "Ahmedabad", note: "Commercial & residential" },
{ name: "Goa", note: "Holiday homes & villas", hot: true }];


export function CitiesGrid() {
  return (
    <section className="relative py-32 bg-stone-50" data-testid="cities-section">
      <div className="pointer-events-none absolute inset-0 -z-10 opacity-40" style={{ backgroundImage: `radial-gradient(circle, #0A254020 1px, transparent 1px)`, backgroundSize: "28px 28px" }} />
      <div className="container-luxury">
        <SectionHeading eyebrow="Where We Operate" title="Across India's" titleAccent="Premier Cities" subtitle="Trusted management for NRI-owned properties in every major Indian metro — and expanding rapidly." />

        <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {CITIES.map((city, i) =>
          <Reveal key={city.name} delay={i * 0.07}>
              <motion.div whileHover={{ y: -4, boxShadow: "0 20px 40px -16px rgba(10,37,64,0.2)" }} transition={{ type: "spring", stiffness: 300, damping: 22 }} className="group relative flex flex-col gap-3 rounded-2xl bg-white p-7 shadow-sm border border-navy-100/60 cursor-default">
                <div className="flex items-start justify-between">
                  <MapPin size={20} className="text-emerald-400 mt-0.5" />
                  {city.hot && <span className="rounded-full bg-emerald-50 border border-emerald-200 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-emerald-600">Active</span>}
                </div>
                <div>
                  <h3 className="font-semibold text-navy-800 tracking-tight">{city.name}</h3>
                  <p className="mt-1 text-xs text-navy-600/60">{city.note}</p>
                </div>
              </motion.div>
            </Reveal>
          )}

          <Reveal delay={0.5}>
            <motion.a href={WA_LINKS.general} target="_blank" rel="noopener noreferrer" whileHover={{ y: -4, boxShadow: "0 20px 40px -16px rgba(0,196,160,0.25)" }} transition={{ type: "spring", stiffness: 300, damping: 22 }} className="group flex flex-col gap-3 rounded-2xl border-2 border-dashed border-emerald-300/60 bg-emerald-400/5 p-7 cursor-pointer">
              <div className="flex items-start justify-between">
                <MapPin size={20} className="text-emerald-300 mt-0.5" />
                <ArrowRight size={16} className="text-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <div>
                <h3 className="font-semibold text-navy-700 tracking-tight">Your City?</h3>
                <p className="mt-1 text-xs text-navy-600/60 leading-relaxed">Not listed? Share it with us — we evaluate feasibility after a quick discussion.</p>
              </div>
            </motion.a>
          </Reveal>
        </div>
      </div>
    </section>);

}